import { useApiClient, RequestConfig } from "@/hooks";
import React, { useMemo } from "react";



export function useEmpresaList() {
  const config = useMemo<RequestConfig>(() => ({
    url: "/empresas/list",
    method: "GET",
  }), []);

  return useApiClient(config);
}